import { Component, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-downgrade-popup',
    templateUrl: './downgrade-popup.component.html',
    styleUrls: ['./downgrade-popup.component.scss'],
    standalone: false
})
export class DowngradePopupComponent {
  @Output() close: EventEmitter<void> = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }
}


